const frontend_url = window.location.origin;

export const oidcConfig = {
  frontend_url: `${frontend_url}`,
  oidc: {
    userManagerSettings: {
      authority: "https://id.sick.com/auth/realms/sickservices",
      automaticSilentRenew: true,
      accessTokenExpiringNotificationTime: 60, // in seconds
      client_id: "public-project-migration",
      filterProtocolClaims: true,
      loadUserInfo: true,
      redirect_uri: `${frontend_url}/auth-callback`,
      response_type: "code",
      post_logout_redirect_uri: `${frontend_url}/login`,
      scope: "openid profile email",
      silent_redirect_uri: `${frontend_url}/silent-refresh`,
    },
    role: {
      token_roles: "role",
      allowed_roles: [],
    },
  },
};
